<script>
    export let value = 0;

    let hovered = 0;
    const stars = [1, 2, 3, 4, 5];

    function setValue(v) {
        value = v;
    }

    function setHover(v) {
        hovered = v;
    }

    function clearHover() {
        hovered = 0;
    }

    $: shown = hovered || value;
</script>

<div class="rating" role="radiogroup" aria-label="Оценка">
    {#each stars as i}
        <button
                type="button"
                class="rating__star"
                class:filled={i <= shown}
                aria-label={`Оценка ${i} из 5`}
                aria-pressed={i === value}
                on:click={() => setValue(i)}
                on:mouseenter={() => setHover(i)}
                on:focus={() => setHover(i)}
                on:mouseleave={clearHover}
                on:blur={clearHover}>
            <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
                <path d="M12 2.6l2.92 6.28 6.88.86-5.06 4.74 1.34 6.82L12 17.95l-6.08 3.35 1.34-6.82L2.2 9.74l6.88-.86z"/>
            </svg>
        </button>
    {/each}
</div>

<style>
    .rating {
        display: inline-flex;
        gap: 4px;
        align-items: center;
    }

    .rating__star {
        background: none;
        border: none;
        padding: 2px;
        cursor: pointer;
        line-height: 0;
        color: #d9d9d9;
        transition: color 120ms ease, transform 120ms ease;
    }

    .rating__star:hover,
    .rating__star:focus-visible {
        transform: scale(1.08);
        outline: none;
    }

    .rating__star:focus-visible {
        box-shadow: 0 0 0 2px rgba(160, 104, 64, 0.35);
        border-radius: 4px;
    }

    .rating__star.filled {
        color: var(--main-color, #a06840);
    }

    .rating__star svg {
        display: block;
        fill: currentColor;
    }
</style>
